import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { SuperAdminService } from '../../services/super-admin/super-admin.service';
import { ToastService } from '../../services/toast/toast.service';
import { LoaderComponent } from '../../atoms/loader/loader.component';
import { SaAddEstablishmentDialogComponent } from './sa-add-establishment-dialog/sa-add-establishment-dialog.component';

@Component({
  selector: 'app-sa-establishments',
  standalone: true,
  imports: [CommonModule, LoaderComponent],
  templateUrl: './sa-establishments.component.html',
  styleUrls: ['./sa-establishments.component.scss', '../../../common-style/admin-list-page.scss'],
})
export class SaEstablishmentsComponent implements OnInit {
  establishments: any[] = [];
  isLoading: boolean = false;

  constructor(
    private superAdminService: SuperAdminService,
    private toastService: ToastService,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.isLoading = true;
    this.superAdminService.listEstablishments().subscribe({
      next: (res: any) => {
        this.establishments = res?.data?.establishments || [];
        this.isLoading = false;
      },
      error: (err) => {
        this.establishments = [];
        this.isLoading = false;
        this.toastService.error(err?.error?.message || 'Failed to load branches.');
      },
    });
  }

  addEstablishment(): void {
    const ref = this.dialog.open(SaAddEstablishmentDialogComponent, {
      width: '680px',
      maxWidth: 'calc(100vw - 32px)', // Prevents horizontal touching the screen edges
      maxHeight: 'calc(100dvh - 32px)' // Prevents vertical overflow
    });
    ref.afterClosed().subscribe((changed: boolean) => {
      if (changed) this.load();
    });
  }

  editEstablishment(establishment: any): void {
    const ref = this.dialog.open(SaAddEstablishmentDialogComponent, {
      width: '680px',
      maxWidth: 'calc(100vw - 32px)',
      maxHeight: 'calc(100dvh - 32px)',
      data: { establishment },
    });
    ref.afterClosed().subscribe((changed: boolean) => {
      if (changed) this.load();
    });
  }
}
